module.exports = __webpack_public_path__ + "24d76a28afc8ad4051a8149df7cacdd9.svg";